import React from 'react';
import { useTranslation } from 'react-i18next';
import { Post } from '../../../components';
import style from './style.module.scss';

const Related = ({ posts }) => {
	// React i18next
	const { t } = useTranslation();

	return (
		<div className={style.related} >
			{posts?.length > 0 && <h2 className={style.title}>{t('Related Posts')}</h2>}

			<div className={style.container}>
				{posts && posts.map((post, index) => <Post key={index} post={post} />)}
			</div>
		</div>
	);
};

export default Related;
